module.exports = __webpack_public_path__ + "img/5.b6c14ee1.jpg";